













import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Swatch extends Vue {
  @Prop() image!: string;
  @Prop({ default: "" }) name!: string;
  @Prop({ default: "" }) code!: string;

  get cdnUrl(): string {
    return process.env.VUE_APP_CDN_URL + "/fabric_swatches/";
  }
}
